import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment-timezone';
import { unitOfTime } from 'moment-timezone';

@Pipe({
  standalone: true,
  name: 'concatDateParams'
})
export class ConcatDateParamsPipe implements PipeTransform {
  public transform(queryParams: Record<string, any>, period: unitOfTime.StartOf): Record<string, any> {
    const from = moment().startOf(period).format('YYYY-MM-DD');
    const to = moment().endOf(period).format('YYYY-MM-DD');

    return { ...queryParams, from, to };
  }
}
